module.exports = __webpack_public_path__ + "img/area.da612980.svg";